export const ButtonType = {
  LOADING: 'loading'
};
